import { ApolloClientProvider } from './state/apollo';
import { AuthProvider } from './state/auth';
import { CTGLoyaltyProvider } from './state/ctg-loyalty-legacy';
import { IntlProvider } from './state/intl';
import { IssueLoyaltyProvider } from './state/issue-loyalty';
import { LocationProvider } from './state/location';
import { LoyaltyProvider } from './state/loyalty';
import { NotificationProvider } from './state/notification';
import { ParamsProvider } from './state/params';
import { RollUpTheRimProvider } from './state/roll-up-the-rim';
import { ThemeProvider } from './state/theme';
import { UniversalSearchProvider } from './state/universal-search';

const providers = [
  ThemeProvider,
  IntlProvider,
  NotificationProvider,
  AuthProvider,
  ApolloClientProvider,
  LocationProvider,
  ParamsProvider,
  CTGLoyaltyProvider,
  LoyaltyProvider,
  RollUpTheRimProvider,
  IssueLoyaltyProvider,
  UniversalSearchProvider,
];

export default providers;
